import { render, staticRenderFns } from "./extra-card.vue?vue&type=template&id=15560444"
import script from "./extra-card.vue?vue&type=script&lang=ts"
export * from "./extra-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiModal: require('/vercel/path0/components/ui/modal.vue').default,UiIconInfo: require('/vercel/path0/components/ui/icon/info.vue').default})
